import { Component } from '@angular/core';
import { Country } from './countries.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { ClientsService } from '../../../../services/clients/clients.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { WsService } from '../../../../services/websocket/WsService';
import { SuperClass } from '../../../../superclass/SuperClass';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-countries',
  templateUrl: './countries.component.html',
  styleUrls: ['./countries.component.css'],
})
export class CountriesComponent extends SuperClass {
  selectedRow: any;
  country: Country[];
  newCountry: Country;
  newCountryForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Vocabularies' },
      {
        label: 'Countries',
        routerLink: [{ outlets: { sub: [RouterConst.COUNTRIES] } }],
      },
    ]);
  }

  reloadData() {
    this.http_getAllCountriesList((data: any) => {
      this.country = data.payload;
    });

    this.selectedRowForm = this.fb.group({
      country_name: new FormControl('', Validators.required),
      iso_code: new FormControl('', Validators.required),
      dial_code: new FormControl('', Validators.required),
    });

    this.newCountryForm = this.fb.group({
      country_name: new FormControl('', Validators.required),
      iso_code: new FormControl('', Validators.required),
      dial_code: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    this.selectedRow = new Country(e.data);
  }

  saveCountryChanges() {
    this.http_updateCountries(this.selectedRow, (data: any) => {
      this.country = data.payload;
      this.showSuccessMessage('Country has been saved');
      this.unselectRow();
    });
  }

  addNewCountry() {
    this.display = true;
    this.newCountry = new Country();
  }

  createNewCountry() {
    this.http_createNewCountry(this.newCountry, (data: any) => {
      this.country = data.payload;
      this.showSuccessMessage('New Country has been created');
      this.unselectRow();
    });
    this.display = false;
  }

  deleteCountry() {
    this.http_deleteCountry(this.selectedRow, (data: any) => {
      this.country = data.payload;
      this.showSuccessMessage('Country has been deleted');
      this.unselectRow();
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/vocabularies/countries/countries.component.ts